// extracted by mini-css-extract-plugin
export default {"user-insights-container":"UserInsights_user-insights-container__FMUy1","snapshot-mode":"UserInsights_snapshot-mode__dWa+y"};